import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export function Auth() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<'login' | 'signup'>(location.pathname === '/signup' ? 'signup' : 'login');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loginData, setLoginData] = useState({
    email: '',
    password: ''
  });
  const [signupData, setSignupData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: ''
  });
  const handleLoginChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLoginData({
      ...loginData,
      [e.target.name]: e.target.value
    });
    if (e.target.name === 'email' && e.target.value.includes('@')) {
      setShowPassword(true);
    }
  };
  const handleSignupChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSignupData({
      ...signupData,
      [e.target.name]: e.target.value
    });
    if (e.target.name === 'password' && e.target.value.length >= 1) {
      setShowConfirmPassword(true);
    }
  };
  const handleLoginSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle login logic here
  };
  const handleSignupSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle signup logic here
  };
  const handleSocialLogin = (provider: string) => {
    // Handle social login logic here
    console.log(`Login with ${provider}`);
  };
  return <div className="min-h-screen flex items-center justify-center px-4 pt-8 pb-12 bg-cover bg-center bg-no-repeat" style={{
    backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/2VXGuWX7WfqatMBg5PRveQ/pp.png')"
  }} data-id="element-1329">
      <div className="max-w-md w-full" data-id="element-1330">
        <Link to="/" className="inline-flex items-center text-[#6C3EF1] hover:text-[#5a32d4] mb-8 transition" data-id="element-1331">
          <ArrowLeft className="h-4 w-4 mr-2" data-id="element-1332" />
          Back to Home
        </Link>

        <div className="bg-white rounded-2xl shadow-xl p-8" data-id="element-1333">
          <div className="mb-8" data-id="element-1334">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/o8GxAvVWkfzEpga9gSEiQA/Lawvo_logo_tm_01_large.png" alt="LawVo Logo" className="h-10 mb-8 mx-auto" data-id="element-1335" />
            <h1 className="text-2xl font-bold text-gray-900 text-center" data-id="element-1336">
              {activeTab === 'login' ? 'Welcome back!' : 'Create your account'}
            </h1>
            <p className="text-sm text-gray-500 text-center mt-2 mb-6" data-id="element-1337">
              {activeTab === 'login' ? <>
                  Don't have an account yet?{' '}
                  <button onClick={() => setActiveTab('signup')} className="text-[#6C3EF1] hover:text-[#5a32d4] font-medium transition" data-id="element-1338">
                    Sign up now
                  </button>
                </> : <>
                  Already have an account?{' '}
                  <button onClick={() => setActiveTab('login')} className="text-[#6C3EF1] hover:text-[#5a32d4] font-medium transition" data-id="element-1339">
                    Sign in
                  </button>
                </>}
            </p>
          </div>

          {/* Login Form */}
          {activeTab === 'login' && <div data-id="element-1340">
              <form onSubmit={handleLoginSubmit} className="space-y-4" data-id="element-1341">
                <div data-id="element-1342">
                  <input type="email" id="login-email" name="email" value={loginData.email} onChange={handleLoginChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6C3EF1] focus:border-transparent transition" placeholder="Enter your email" required data-id="element-1343" />
                </div>
                {showPassword && <div data-id="element-1344">
                    <input type="password" id="login-password" name="password" value={loginData.password} onChange={handleLoginChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6C3EF1] focus:border-transparent transition" placeholder="Enter your password" required data-id="element-1345" />
                    <div className="text-right mt-1.5" data-id="element-1346">
                      <a href="#" className="text-xs text-[#00dace] hover:text-[#00b8aa] transition" data-id="element-1347">
                        Forgot your password?
                      </a>
                    </div>
                  </div>}
                <button type="submit" className="w-full bg-[#6C3EF1] text-white py-3 px-6 rounded-lg hover:bg-[#5a32d4] transition font-medium" data-id="element-1348">
                  Continue
                </button>
              </form>

              {/* Divider */}
              <div className="flex items-center my-6" data-id="element-1349">
                <div className="flex-1 border-t border-gray-300" data-id="element-1350"></div>
                <span className="px-4 text-sm text-gray-500" data-id="element-1351">or use</span>
                <div className="flex-1 border-t border-gray-300" data-id="element-1352"></div>
              </div>

              {/* Social Login Buttons */}
              <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-1353">
                <button onClick={() => handleSocialLogin('google')} className="flex items-center justify-center gap-2 px-4 py-3 border-2 border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition" data-id="element-1354">
                  <img src="https://www.google.com/favicon.ico" alt="Google" className="w-5 h-5" data-id="element-1355" />
                  <span className="text-sm font-medium text-gray-700" data-id="element-1356">
                    Google
                  </span>
                </button>
                <button onClick={() => handleSocialLogin('microsoft')} className="flex items-center justify-center gap-2 px-4 py-3 border-2 border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition" data-id="element-1357">
                  <svg className="w-5 h-5" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1358">
                    <rect width="11" height="11" fill="#F25022" data-id="element-1359" />
                    <rect x="12" width="11" height="11" fill="#7FBA00" data-id="element-1360" />
                    <rect y="12" width="11" height="11" fill="#00A4EF" data-id="element-1361" />
                    <rect x="12" y="12" width="11" height="11" fill="#FFB900" data-id="element-1362" />
                  </svg>
                  <span className="text-sm font-medium text-gray-700" data-id="element-1363">
                    Microsoft
                  </span>
                </button>
                <button onClick={() => handleSocialLogin('linkedin')} className="flex items-center justify-center gap-2 px-4 py-3 border-2 border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition" data-id="element-1364">
                  <svg className="w-5 h-5" fill="#0A66C2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1365">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-1366" />
                  </svg>
                  <span className="text-sm font-medium text-gray-700" data-id="element-1367">
                    LinkedIn
                  </span>
                </button>
                <button onClick={() => handleSocialLogin('apple')} className="flex items-center justify-center gap-2 px-4 py-3 border-2 border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition" data-id="element-1368">
                  <svg className="w-5 h-5" fill="#000000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1369">
                    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" data-id="element-1370" />
                  </svg>
                  <span className="text-sm font-medium text-gray-700" data-id="element-1371">
                    Apple
                  </span>
                </button>
              </div>
            </div>}

          {/* Signup Form */}
          {activeTab === 'signup' && <div data-id="element-1372">
              <form onSubmit={handleSignupSubmit} className="space-y-4" data-id="element-1373">
                <div className="grid grid-cols-2 gap-4" data-id="element-1374">
                  <div data-id="element-1375">
                    <input type="text" id="firstName" name="firstName" value={signupData.firstName} onChange={handleSignupChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6C3EF1] focus:border-transparent transition" placeholder="First Name" required data-id="element-1376" />
                  </div>
                  <div data-id="element-1377">
                    <input type="text" id="lastName" name="lastName" value={signupData.lastName} onChange={handleSignupChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6C3EF1] focus:border-transparent transition" placeholder="Last Name" required data-id="element-1378" />
                  </div>
                </div>
                <div data-id="element-1379">
                  <input type="email" id="signup-email" name="email" value={signupData.email} onChange={handleSignupChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6C3EF1] focus:border-transparent transition" placeholder="Email Address" required data-id="element-1380" />
                </div>
                <div data-id="element-1381">
                  <input type="tel" id="phone" name="phone" value={signupData.phone} onChange={handleSignupChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6C3EF1] focus:border-transparent transition" placeholder="Phone Number" required data-id="element-1382" />
                </div>
                <div data-id="element-1383">
                  <input type="password" id="signup-password" name="password" value={signupData.password} onChange={handleSignupChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6C3EF1] focus:border-transparent transition" placeholder="Password" required data-id="element-1384" />
                </div>
                {showConfirmPassword && <div data-id="element-1385">
                    <input type="password" id="confirmPassword" name="confirmPassword" value={signupData.confirmPassword} onChange={handleSignupChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6C3EF1] focus:border-transparent transition" placeholder="Confirm Password" required data-id="element-1386" />
                  </div>}
                <div className="flex items-start" data-id="element-1387">
                  <input type="checkbox" id="terms" className="h-4 w-4 text-[#6C3EF1] focus:ring-[#6C3EF1] border-gray-300 rounded mt-1" required data-id="element-1388" />
                  <label htmlFor="terms" className="ml-2 text-xs text-gray-600" data-id="element-1389">
                    I confirm that I have read, understood, and agree to LawVo's{' '}
                    <a href="#" className="text-[#00dace] hover:underline" data-id="element-1390">
                      Terms & Conditions
                    </a>{' '}
                    and{' '}
                    <a href="#" className="text-[#00dace] hover:underline" data-id="element-1391">
                      Privacy Policy
                    </a>
                  </label>
                </div>
                <div className="flex items-start" data-id="element-1392">
                  <input type="checkbox" id="marketing" className="h-4 w-4 text-[#6C3EF1] focus:ring-[#6C3EF1] border-gray-300 rounded mt-1" data-id="element-1393" />
                  <label htmlFor="marketing" className="ml-2 text-xs text-gray-600" data-id="element-1394">
                    I agree to receive updates, offers, and communications from
                    LawVo.
                  </label>
                </div>
                <button type="submit" className="w-full bg-[#6C3EF1] text-white py-3 px-6 rounded-lg hover:bg-[#5a32d4] transition font-medium" data-id="element-1395">
                  Create Account
                </button>
              </form>

              {/* Divider */}
              <div className="flex items-center my-6" data-id="element-1396">
                <div className="flex-1 border-t border-gray-300" data-id="element-1397"></div>
                <span className="px-4 text-sm text-gray-500" data-id="element-1398">or use</span>
                <div className="flex-1 border-t border-gray-300" data-id="element-1399"></div>
              </div>

              {/* Social Signup Buttons */}
              <div className="grid grid-cols-2 gap-3" data-id="element-1400">
                <button onClick={() => handleSocialLogin('google')} className="flex items-center justify-center gap-2 px-4 py-3 border-2 border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition" data-id="element-1401">
                  <img src="https://www.google.com/favicon.ico" alt="Google" className="w-5 h-5" data-id="element-1402" />
                  <span className="text-sm font-medium text-gray-700" data-id="element-1403">
                    Google
                  </span>
                </button>
                <button onClick={() => handleSocialLogin('microsoft')} className="flex items-center justify-center gap-2 px-4 py-3 border-2 border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition" data-id="element-1404">
                  <svg className="w-5 h-5" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1405">
                    <rect width="11" height="11" fill="#F25022" data-id="element-1406" />
                    <rect x="12" width="11" height="11" fill="#7FBA00" data-id="element-1407" />
                    <rect y="12" width="11" height="11" fill="#00A4EF" data-id="element-1408" />
                    <rect x="12" y="12" width="11" height="11" fill="#FFB900" data-id="element-1409" />
                  </svg>
                  <span className="text-sm font-medium text-gray-700" data-id="element-1410">
                    Microsoft
                  </span>
                </button>
                <button onClick={() => handleSocialLogin('linkedin')} className="flex items-center justify-center gap-2 px-4 py-3 border-2 border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition" data-id="element-1411">
                  <svg className="w-5 h-5" fill="#0A66C2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1412">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-1413" />
                  </svg>
                  <span className="text-sm font-medium text-gray-700" data-id="element-1414">
                    LinkedIn
                  </span>
                </button>
                <button onClick={() => handleSocialLogin('apple')} className="flex items-center justify-center gap-2 px-4 py-3 border-2 border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition" data-id="element-1415">
                  <svg className="w-5 h-5" fill="#000000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1416">
                    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" data-id="element-1417" />
                  </svg>
                  <span className="text-sm font-medium text-gray-700" data-id="element-1418">
                    Apple
                  </span>
                </button>
              </div>
            </div>}
        </div>

        {/* Mobile App Download Section */}
        <div className="mt-5 flex items-center justify-center gap-3" data-id="element-1419">
          <a href="#" className="inline-block hover:opacity-80 transition" data-id="element-1420">
            <img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83" alt="Download on the App Store" className="h-[48px] w-auto" data-id="element-1421" />
          </a>
          <a href="#" className="inline-block hover:opacity-80 transition" data-id="element-1422">
            <img src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" alt="Get it on Google Play" className="h-[72px] w-auto" data-id="element-1423" />
          </a>
        </div>

        {/* Lawyer Signup Link */}
        {activeTab === 'signup' && <div className="mt-8 text-center" data-id="element-1424">
            <Link to="/lawyer-signup" className="text-sm text-[#6C3EF1] hover:text-[#5a32d4] transition font-medium" data-id="element-1425">
              Are you a lawyer? Sign up here &rarr;
            </Link>
          </div>}
      </div>
    </div>;
}